import type { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import externalTeam from '@/data/externalTeam';
import internalTeam from '@/data/internalTeam';
import type { RootState } from '@/store';
import { set } from '@/store/Opportunity/ProjectTeam';

export default function ProjectTeam() {
  const dispatch = useDispatch();
  //const projectTeamState = useSelector((state: RootState) => state.project.projectTeam)
  const opportunityProjectTeamSate = useSelector((state: RootState) => state.opportunity.projectTeam);
  const changeHandler = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className='mt-0 text-primaryColor-normal'>Project Team</h2>
      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Project Executive <sup>*</sup>
        </label>

        <select
          className='form-input px-2 py-2 appearance-none'
          name='projectExecutive'
          value={opportunityProjectTeamSate.projectExecutive}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Executive
          </option>
          {internalTeam.map((s, index) => (
            <option key={index} value={s.Employee_Name}>
              {s.Employee_Name}
            </option>
          ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Development Manager <sup>*</sup>
        </label>
        <select
          className='form-input px-2 py-2 appearance-none'
          name='developmentManager'
          value={opportunityProjectTeamSate.developmentManager}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Development Manager
          </option>
          {internalTeam.map((s, index) => (
            <option key={index} value={s.Employee_Name}>
              {s.Employee_Name}
            </option>
          ))}
        </select>
      </div>
      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Development Associates <sup>*</sup>
        </label>
        <select
          className='form-input px-2 py-2 appearance-none'
          name='developmentAssociates'
          value={opportunityProjectTeamSate.developmentAssociates}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Development Associates
          </option>
          {internalTeam
            .filter((t) => t.Organization === 'CCLF')
            .map((s, index) => (
              <option key={index} value={s.Employee_Name}>
                {s.Employee_Name}
              </option>
            ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Investment Associate</label>
        <select
          className='form-input px-2 py-2 appearance-none'
          name='investmentAssociates'
          value={opportunityProjectTeamSate.investmentAssociates}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Investment Associate
          </option>
          {internalTeam
            .filter((t) => t.Organization === 'CHA')
            .map((s, index) => (
              <option key={index} value={s.Employee_Name}>
                {s.Employee_Name}
              </option>
            ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Construction Manager <sup>*</sup>
        </label>
        <select
          className='form-input px-2 py-2 appearance-none'
          name='constructionManager'
          value={opportunityProjectTeamSate.constructionManager}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Construction Manager
          </option>
          {externalTeam
            .filter((t) => t.Service_Type === 'Architect')
            .map((s, index) => (
              <option key={index} value={s.Company_Name}>
                {s.Company_Name}
              </option>
            ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>QA/QC</label>

        <select
          className='form-input px-2 py-2 appearance-none'
          name='qcqa'
          value={opportunityProjectTeamSate.qcqa}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select QA/QC
          </option>
          {externalTeam
            .filter((t) => t.Service_Type === 'Engineer')
            .map((s, index) => (
              <option key={index} value={s.Company_Name}>
                {s.Company_Name}
              </option>
            ))}
        </select>
      </div>
    </>
  );
}
